import useGetDefaultStack from '@hooks/api/queries/modes/useGetDefaultStack';
import { Box, CircularProgress } from '@mui/material';
import ControlModeAuthority from '@src/components/Home/Config/Stacks/ControlModesAuthority';
import { isSuperAdmin } from '@src/services/auth';
import { UserRole } from '@src/services/auth/roles';
import storeConnector from '@store/storeConnector';
import { useState } from 'react';
import StackContent from './components/StackContent';
import StackModal from './StackModal';
import { stacksMain, stacksWrapper } from './styles';

interface HMIDefaultProps {
  role: UserRole;
}

function HMIDefault({ role }: HMIDefaultProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const {
    data: defaultStack,
    isFetching,
    isRefetching,
    failureCount,
  } = useGetDefaultStack();

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  if ((isFetching || isRefetching) && !failureCount) {
    return <CircularProgress />;
  }

  const isAdmin = isSuperAdmin(role);

  return (
    <Box component='main' sx={stacksMain}>
      <ControlModeAuthority />
      <Box component='section' sx={stacksWrapper}>
        <StackContent
          defaultStack={defaultStack}
          isAdmin={isAdmin}
          onActionClick={handleModalOpen}
        />

        <StackModal
          stackId={defaultStack?.id}
          open={modalOpen}
          onClose={handleModalClose}
          isDefault={true}
        />
      </Box>
    </Box>
  );
}

HMIDefault.displayName = 'HMIDefault';

export default storeConnector(HMIDefault, {
  user: ['role'],
});
